export default {
  DISABLED: 'disableSubtitles',
};
